<template>
  <div class="site-page home-page">
    <HomeCarousel />

    <section class="home-block intro-block">
      <div class="site-container">
        <div class="intro-card">
          <div class="intro-left">
            <h2 class="section-title">{{ company.title }}</h2>
            <div class="title-line">
              <div class="title-mark"></div>
            </div>
            <p v-for="paragraph in company.content" :key="paragraph">
              {{ paragraph }}
            </p>
          </div>
          <div class="intro-right">
            <img :src="companyImage" alt="新西兰风景" @error="onCompanyImageError">
          </div>
        </div>
      </div>
    </section>

    <section class="home-block project-block">
      <div class="site-container">
        <h2 class="section-title center">新西兰项目</h2>
        <div class="project-grid">
          <div class="project-card" v-for="item in projects" :key="item.id" @click="goProject(item)">
            <h3>{{ item.name }}</h3>
            <p><span>办理周期：</span>{{ item.period }}</p>
            <p><span>投资金额：</span>{{ item.amount }}</p>
            <p><span>英文要求：</span>{{ item.english }}</p>
            <button type="button">查看详情</button>
          </div>
          <div class="project-card more-card" @click="$router.push('/visa')">
            <div class="more-inner">
              <span>查看更多</span>
              <img src="@/assets/imgs/ysgj_005@2x.png" alt="箭头">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="home-block advantage-block">
      <div class="site-container">
        <h2 class="section-title center">源盛优势</h2>
        <div class="advantage-grid">
          <div class="advantage-card" v-for="item in advantages" :key="item.title">
            <div class="icon">
              <img :src="item.icon" alt="">
            </div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="home-block news-block">
      <div class="site-container">
        <div class="news-grid">
          <article class="section-card news-col" v-for="col in newsColumns" :key="col.key">
            <header>
              <div class="col-title">
                <img :src="col.icon" alt="">
                <h3>{{ col.title }}</h3>
              </div>
              <router-link :to="newsListRoute(col.key)" class="more-link">
                <span class="arrow-icon">→</span>
              </router-link>
            </header>
            <ul>
              <li v-for="item in col.items.slice(0, 4)" :key="item.id" @click="openNews(item)">
                <span class="txt">{{ item.title }}</span>
              </li>
            </ul>
            <div v-if="col.preview" class="news-preview" @click="openNews(col.preview)">
              <div class="thumb">
                <img :src="col.preview.cover || col.preview.image" alt="">
              </div>
              <div class="meta">
                <p class="title">{{ col.preview.title }}</p>
                <p class="date">{{ col.preview.date }}</p>
              </div>
            </div>
            <ul v-if="col.items.length > 4">
              <li v-for="item in col.items.slice(4)" :key="item.id" @click="openNews(item)">
                <span class="txt">{{ item.title }}</span>
              </li>
            </ul>
          </article>
        </div>
      </div>
    </section>

    <div class="float-tools">
      <button class="tool-btn" type="button" @click="scrollTop">
        <img src="@/assets/imgs/ysgj_006@2x.png" alt="顶部">
      </button>
      <button class="tool-btn" type="button" @click="showMessage">
        <img src="@/assets/imgs/ysgj_007@2x.png" alt="咨询">
      </button>
    </div>
  </div>
</template>

<script>
import HomeCarousel from '@/components/HomeCarousel.vue'
import {
  buildNewsDetailPath,
  buildProjectDetailPath,
  projectList,
  buildHomeNewsColumns,
} from '@/data/siteData'
import { getHomeData } from '@/api'

const DEFAULT_ADVANTAGE_ICONS = [
  require('@/assets/imgs/ysgj_009@2x.png'),
  require('@/assets/imgs/ysgj_010@2x.png'),
  require('@/assets/imgs/ysgj_011@2x.png'),
  require('@/assets/imgs/ysgj_012@2x.png'),
]

const DEFAULT_COMPANY_IMAGE = require('@/assets/imgs/ysgj_004@2x.png')

const DEFAULT_NEWS_COLUMN_ICONS = {
  biz: require('@/assets/imgs/ysgj_013@2x.png'),
  news: require('@/assets/imgs/ysgj_014@2x.png'),
  cases: require('@/assets/imgs/ysgj_015@2x.png'),
}

export default {
  name: 'Home',
  components: { HomeCarousel },
  data() {
    return {
      company: {
        title: '关于源盛',
        content: [
          '源盛国际2008年创立，是一家在中国和新西兰注册的国际化投资与移民服务机构，在上海和奥克兰均设有办公室。深耕行业近二十年，我们始终聚焦新西兰全类别签证，致力于为客户提供从签证申请到海外落地的一站式解决方案。',
          '由经验丰富的律师、首批全牌照持牌移民顾问带领的团队秉承“诚信、专业、稳健”的理念，已助力上千家庭成功移居新西兰。经我们评估后受理的案子成功率极高，即便是上千商业投资移民家庭有拒签记录的疑难案例，也常能凭借丰富经验找到突破口。',
          '依托新西兰本土资源和中新双城协同优势，我们能第一时间把握政策动态，确保申请材料严谨合规，配套登陆后的安居支持，是您移居新西兰全程无忧的可靠伙伴。',
        ],
        image: DEFAULT_COMPANY_IMAGE,
      },
      projects: projectList.filter((p) => [1, 2, 3, 5, 6].includes(p.id)),
      advantages: [
        { title: '18年+专注办理', desc: '新西兰全类别移民签证', icon: DEFAULT_ADVANTAGE_ICONS[0] },
        { title: '帮助1200+商业投资移民家庭', desc: '', icon: DEFAULT_ADVANTAGE_ICONS[1] },
        { title: '新西兰资深商业移民\n持牌顾问领衔中新双城\n协同服务，实现无时差对谈', desc: '', icon: DEFAULT_ADVANTAGE_ICONS[2] },
        { title: '结合中国国情', desc: '制定新西兰移民签证方案', icon: DEFAULT_ADVANTAGE_ICONS[3] },
      ],
      newsColumns: buildHomeNewsColumns(),
      companyImageErrored: false,
    }
  },
  created() {
    this.fetchHomeData()
  },
  computed: {
    companyImage() {
      if (this.companyImageErrored || !this.company.image) {
        return DEFAULT_COMPANY_IMAGE
      }

      return this.company.image
    },
  },
  methods: {
    async fetchHomeData() {
      try {
        const data = await getHomeData()
        this.company = {
          title: data.company?.title || this.company.title,
          content: Array.isArray(data.company?.content) && data.company.content.length
            ? data.company.content
            : this.company.content,
          image: data.company?.image || this.company.image,
        }
        this.companyImageErrored = false
        if (Array.isArray(data.projects) && data.projects.length) {
          this.projects = data.projects.slice(0, 5)
        }
        if (Array.isArray(data.advantages) && data.advantages.length) {
          this.advantages = data.advantages.map((item, index) => ({
            ...item,
            icon: DEFAULT_ADVANTAGE_ICONS[index] || item.icon || DEFAULT_ADVANTAGE_ICONS[0],
          }))
        }
        if (Array.isArray(data.newsColumns) && data.newsColumns.length) {
          this.newsColumns = data.newsColumns.map((item) => ({
            ...item,
            icon: DEFAULT_NEWS_COLUMN_ICONS[item.key] || item.icon || DEFAULT_NEWS_COLUMN_ICONS.biz,
          }))
        }
      } catch (error) {
        // 保留默认值，不清空
      }
    },
    onCompanyImageError() {
      this.companyImageErrored = true
    },
    goProject(item) {
      this.$router.push(buildProjectDetailPath(item.id))
    },
    openNews(item) {
      this.$router.push(buildNewsDetailPath(item.id))
    },
    newsListRoute(type) {
      return { path: '/news', query: { tab: type } }
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    showMessage() {
      this.$Message.info('在线咨询功能开发中...')
    },
  },
}
</script>

<style scoped>
.home-page {
  background: #fff;
}

.home-block {
  padding: 56px 0 0;
}

.intro-block {
  background: #fff;
  padding-top: 64px;
}

.intro-card {
  background: transparent;
  box-shadow: none;
  border-radius: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 480px;
  gap: 56px;
  align-items: start;
}

.title-line {
  position: relative;
  border-bottom: 1px solid #e6ebf2;
  margin: 16px 0 24px;
}

.title-mark {
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 80px;
  height: 3px;
  background: var(--site-blue);
  border-radius: 2px;
}

.intro-left p {
  font-size: 16px;
  line-height: 1.9;
  color: #2d2f33;
}

.intro-left p + p {
  margin-top: 16px;
}

.intro-right {
  border-radius: 16px;
  overflow: hidden;
  aspect-ratio: 1361 / 1532;
}

.intro-right img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.section-title.center {
  text-align: center;
  margin-bottom: 28px;
  font-size: 28px;
}

.project-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.project-card {
  background: #fff;
  border: 1px solid var(--site-border);
  border-radius: 12px;
  padding: 24px 24px 20px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.project-card:hover {
  border-color: #ccdbed;
  box-shadow: 0 6px 18px rgba(18, 87, 167, 0.1);
  transform: translateY(-2px);
}

.project-card h3 {
  font-size: 17px;
  line-height: 1.4;
  color: #2d2f33;
  font-weight: 700;
  margin-bottom: 12px;
}

.project-card p {
  font-size: 14px;
  line-height: 1.8;
  color: #4a5463;
}

.project-card p span {
  color: #9ca5b2;
}

.project-card button {
  width: 100%;
  margin-top: 14px;
  height: 36px;
  border: none;
  border-radius: 18px;
  background: var(--site-blue);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.project-card button:hover {
  background: var(--site-blue-dark);
}

.more-card {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  border-style: dashed;
  border-color: #c8d4e4;
  background: #fff;
}

.more-inner {
  text-align: center;
}

.more-inner span {
  display: block;
  font-size: 15px;
  color: #4a5463;
  margin-bottom: 8px;
}

.more-inner img {
  width: 28px;
  height: 28px;
}

.advantage-block {
  background: url('~@/assets/imgs/ysgj_008@2x.png') no-repeat center center;
  background-size: cover;
  margin-top: 30px;
  padding: 36px 0 42px;
}

.advantage-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

.advantage-card {
  background: #fff;
  border-radius: 12px;
  text-align: center;
  padding: 32px 24px 28px;
  box-shadow: 0 2px 12px rgba(17, 80, 147, 0.06);
}

.advantage-card .icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.advantage-card .icon img {
  width: 72px;
  height: 72px;
}

.advantage-card h3 {
  font-size: 16px;
  color: #2d2f33;
  margin-bottom: 8px;
  line-height: 1.5;
  white-space: pre-line;
  font-weight: 700;
}

.advantage-card p {
  font-size: 14px;
  color: #5e6876;
  line-height: 1.6;
}

.news-block {
  background: #fff;
  padding: 30px 0;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.news-col {
  padding: 20px;
  box-shadow: none;
  border: 1px solid #f0f2f5;
}

.news-col header {
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #edf1f6;
  margin-bottom: 10px;
}

.col-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.col-title img {
  width: 28px;
  height: 28px;
}

.col-title h3 {
  font-size: 17px;
  color: #2d2f33;
  font-weight: 700;
}

.more-link {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--site-blue);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
}

.arrow-icon {
  display: block;
  line-height: 1;
  transform: translateX(-1px);
}

.news-col ul li {
  height: 42px;
  display: flex;
  align-items: center;
  cursor: pointer;
}



.news-col ul li .txt {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #4a5463;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-col ul li:hover .txt {
  color: var(--site-blue);
}

.news-preview {
  margin: 8px 0;
  border-radius: 8px;
  padding: 10px;
  display: grid;
  grid-template-columns: 100px 1fr;
  gap: 10px;
  cursor: pointer;
}

.news-preview .thumb {
  height: 64px;
  border-radius: 6px;
  overflow: hidden;
}

.news-preview .thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-preview .title {
  font-size: 12px;
  line-height: 1.5;
  color: #4d5a70;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-preview .date {
  margin-top: 4px;
  font-size: 12px;
  color: #9aa3b1;
}

.float-tools .tool-btn {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  box-shadow: none;
  border: none;
}

.float-tools .tool-btn img {
  width: 46px;
  height: 46px;
}
</style>
